import { render, staticRenderFns } from "./CreateEditSupplierModal.vue?vue&type=template&id=2dafb0a5&scoped=true&"
import script from "./CreateEditSupplierModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditSupplierModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditSupplierModal.vue?vue&type=style&index=0&id=2dafb0a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dafb0a5",
  null
  
)

export default component.exports